// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"d8fa7296","787":"44a64c6f"}[chunkId] + ".chunk.js";
};